<template>
  <div>
    <b-table
      :items="items"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
    >
      <template #cell(show_details)="row">
        <b-button
          size="sm"
          class="mr-2"
          @click.stop="getLogDetail(row);"
        >
          {{ row.detailsShowing ? 'Hide' : 'Log' }} Details
        </b-button>
      </template>
      <template #row-details="row">
        <b-card>
          <div>
            <b-table
              stacked
              :items="row.item.logs"
            >
              <template #cell(tracking_data)="data">
                <json-viewer
                  :value="data.item.tracking_data"
                  copyable
                  boxed
                />
              </template>
            </b-table>
          </div>
          <b-button
            size="sm"
            @click="row.toggleDetails"
          >
            Hide Log Details
          </b-button>
        </b-card>
      </template>
    </b-table>
  </div>
</template>

<script>
import api from '@/api';

export default {
  props: {
    project: {
      type: Object,
      required: true,
      validator: (value) => !!value.projectName,
    },
  },
  data() {
    return {
      sortBy: 'time_stamp',
      sortDesc: true,
      fields: ['time_stamp', 'createdBy', 'status', 'show_details'],
      items: [],
    };
  },
  created: function () {
    this.getLogsHistory();
  },
  methods: {
    async getLogsHistory() {
      const logs = await api.getProjectLogs(this.project.projectName);
      const arr = logs.map((log) => {
        return {
          isActive: true,
          time_stamp: log.Timestamp,
          createdBy: log.createdBy,
          status: log.status,
          provisionid: log.RowKey,
        };
      });
      this.items = arr;
    },
    async getLogDetail(row) {
      const detail = await api.getProjectLogDetails(this.project.projectName, row.item.provisionid);
      row.item.detail = detail;
      row.item.logs = row.item.detail.map((tracking) => {
        return {
          time_stamp: tracking.Timestamp,
          message: tracking.message,
          status: tracking.status,
          tracking_data: tracking.trackingData,
        };
      });
      row.toggleDetails();
    },
  },
};
</script>
